































































































































import Vue from "vue";
import { AdminReceipt } from "@/common/models/Receipt";
import ReceiptDialogData from "./ReceiptDialogData.vue";
import CurrencyValue from "@/common/components/CurrencyValue.vue";
import { humanReadableDate } from "@/common/utils/DateUtils";

export default Vue.extend({
  name: "ReceiptDialog",
  components: {
    ReceiptDialogData,
    CurrencyValue,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    receipt: {
      type: Object,
      default: (): AdminReceipt | null => null,
    },
  },

  data() {
    return {
      translationPrefix: "modules.receipts.components.receipt-dialog",
      dialog: false,
    };
  },

  watch: {
    receipt: {
      immediate: true,
      handler(): void {
        this.dialog = !!this.receipt || this.loading;
      },
    },
    loading: {
      immediate: true,
      handler(): void {
        this.dialog = !!this.receipt || this.loading;
      },
    },
  },

  methods: {
    humanReadableDate,

    close(): void {
      this.$emit("close");
    },
  },
});
